import wcs from '@/scripts/libs/wcs/index'
import { RoxLensPanel } from './rox-lens-panel/RoxLensPanel'
import { WcsUser } from './wcs/user'

export class EarlyAccess {
  static isEarlyAccessEnabled = () => {
    const { earlyAccess } = wcs.getStoreConfig()

    return earlyAccess?.active && WcsUser.isEarlyAccessActivityInUserClusterCookie()
  }

  static canPerformEarlyAccessCall = () => {
    const earlyAccessDone = sessionStorage.getItem('eaactivitydone')
    return EarlyAccess.isEarlyAccessEnabled() && !earlyAccessDone
  }

  static checkAndWriteEarlyAccessCookie = () => {
    const { earlyAccess } = wcs.getStoreConfig()

    if (earlyAccess?.active) {
      const promoFromUrl = WcsUser.getUserClusterPromoFromUrl()
      const splitEarlyAccessUrlParams = earlyAccess?.urlParamValue.split(',')
      const isAnyPromoInsideEarlyAccessUrl = promoFromUrl.some((promo) =>
        splitEarlyAccessUrlParams.includes(promo)
      )

      if (isAnyPromoInsideEarlyAccessUrl) {
        WcsUser.writeUserClusterCookie(earlyAccess?.cookie)
      }
    }
  }
  static checkAndEmitEventForRoxLensPanel = () => {
    const { roxLensPanel } = wcs.getStoreConfig()
    if (roxLensPanel.isEnabled) {
      RoxLensPanel.emitEarlyAccessEligibleEvent()
    }
  }
}
